import { capitalizeAllWords } from 'Helpers/Formats';
import moment from 'moment/moment';

export const getTooltipData = (meetingResource, householdResource) => (
  [
    {
      prompt: 'Meeting Type',
      value: capitalizeAllWords(meetingResource.attr('meetingType')),
    },
    {
      prompt: 'Meeting Title',
      value: meetingResource.attr('title'),
    },
    {
      prompt: 'Starts',
      value: moment(meetingResource.attr('startTime')).format('lll'),
    },
    {
      prompt: 'Ends',
      value: moment(meetingResource.attr('endTime')).format('lll'),
    },
    {
      prompt: 'Primary Client',
      value: `${householdResource.attr('primaryClientFirstName')} ${householdResource.attr('primaryClientLastName')} (${householdResource.attr('primaryClientEmail')})`,
    },
    {
      prompt: 'Household ID',
      value: householdResource.id(),
    },
    {
      prompt: 'Meeting ID',
      value: meetingResource.id(),
    },
  ]
);
